
import { Vue } from "vue-class-component";

export default class Xcircle extends Vue {}
